<template>
  <div
    :class="`bg-${getColorMode.globalBackground} text-${getColorMode.text} row`"
  >
    <div class="container">
      <footer
        class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top"
      >
        <p class="col-md-4 mb-0 text-muted">
          © {{ new Date().getFullYear() }} MobySuite
        </p>

        <a
          href="/"
          class="col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto"
        >
          <img
            :src="logo"
            alt="MobySuite logo"
            height="35"
            :class="`logo-${getColorMode.background}`"
          />
        </a>

        <ul class="nav col-md-4 justify-content-end">
          <li class="nav-item">
            <a href="/" class="nav-link px-2 text-muted"
              ><font-awesome-icon :icon="['fal', 'home-alt']"
            /></a>
          </li>
        </ul>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  data() {
    return {
      logo: require("@/assets/images/general/logo-mobydocs.svg"),
    };
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
